import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterSvgComponent } from './filter-svg.component';

@NgModule({
  declarations: [
    FilterSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    FilterSvgComponent
  ]
})
export class FilterSvgModule { }
